function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_289",
  "data-name": "Rectangle 289",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2841",
  "data-name": "Path 2841",
  d: "M13.1,8.769.48,11.22v9.269a.512.512,0,0,0,.361.488l8.207,2.51a.756.756,0,0,0,.369.019l12.208-2.37a.511.511,0,0,0,.413-.5V11.786a.508.508,0,0,0-.361-.487L13.471,8.788a.773.773,0,0,0-.37-.019",
  transform: "translate(0.741)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2842",
  "data-name": "Path 2842",
  d: "M9.272,24a1.254,1.254,0,0,1-.364-.054L.7,21.436a.985.985,0,0,1-.7-.947V11.22a.481.481,0,0,1,.388-.472L13.009,8.3a1.224,1.224,0,0,1,.6.031l8.208,2.511a.983.983,0,0,1,.7.946v8.849a.993.993,0,0,1-.8.972L9.509,23.978A1.252,1.252,0,0,1,9.272,24M.96,11.615v8.874l8.228,2.539a.29.29,0,0,0,.137.008l12.209-2.371.024-8.879L13.33,9.247a.3.3,0,0,0-.137-.007ZM13.1,8.769h0Z",
  transform: "translate(0.741)",
  fill: "#414143"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2843",
  "data-name": "Path 2843",
  d: "M13.288,8.733.48,11.22V3.28a.509.509,0,0,1,.413-.5L12.681.491a.509.509,0,0,1,.607.5Z",
  transform: "translate(0.741)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2844",
  "data-name": "Path 2844",
  d: "M.48,11.7A.481.481,0,0,1,0,11.22V3.28a.993.993,0,0,1,.8-.972L12.59.02a.976.976,0,0,1,.817.207.984.984,0,0,1,.361.764V8.733a.48.48,0,0,1-.388.471L.572,11.691A.486.486,0,0,1,.48,11.7M12.808.991.985,3.251.962,10.637l11.846-2.3Zm.48,7.742h0Z",
  transform: "translate(0.741)",
  fill: "#414143"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2845",
  "data-name": "Path 2845",
  d: "M8.446,12.528a.48.48,0,0,1-.091-.951L14.94,10.3a.48.48,0,0,1,.184.942L8.539,12.519a.488.488,0,0,1-.093.009",
  transform: "translate(0.741)",
  fill: "#414143"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2846",
  "data-name": "Path 2846",
  d: "M9.231,14.376a.5.5,0,0,1-.141-.021L.34,11.678a.48.48,0,1,1,.281-.917l8.751,2.676a.48.48,0,0,1-.141.939",
  transform: "translate(0.741)",
  fill: "#414143"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2847",
  "data-name": "Path 2847",
  d: "M9.23,23.448V13.9l12.387-2.4",
  transform: "translate(0.741)",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2848",
  "data-name": "Path 2848",
  d: "M9.231,23.928a.48.48,0,0,1-.48-.48V13.9a.479.479,0,0,1,.388-.471l12.387-2.406a.48.48,0,0,1,.184.943l-12,2.329v9.157a.48.48,0,0,1-.48.48",
  transform: "translate(0.741)",
  fill: "#414143"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2849",
  "data-name": "Path 2849",
  d: "M12.122,13.343v9.638l7.453-1.448V11.9Z",
  transform: "translate(0.741)",
  fill: "#71ef9e"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2850",
  "data-name": "Path 2850",
  d: "M12.123,23.461a.48.48,0,0,1-.48-.48V13.343a.481.481,0,0,1,.388-.471l7.452-1.447a.472.472,0,0,1,.4.1.481.481,0,0,1,.174.37v9.638a.479.479,0,0,1-.388.471l-7.452,1.447a.486.486,0,0,1-.092.009m.48-9.722V22.4l6.492-1.26v-8.66Z",
  transform: "translate(0.741)",
  fill: "#414143"
});

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.65e56aec.svg";
export { ForwardRef as ReactComponent };